import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'María',
  location: 'Ciudad de México',
  time: '2 minutos'
}, {
  name: 'Sofía',
  location: 'Bogotá',
  time: '5 minutos'
}, {
  name: 'Valentina',
  location: 'Buenos Aires',
  time: '30 segundos'
}, {
  name: 'Camila',
  location: 'Santiago',
  time: '1 minuto'
}, {
  name: 'Isabella',
  location: 'Lima',
  time: '3 minutos'
}, {
  name: 'Lucía',
  location: 'Madrid',
  time: '4 minutos'
}, {
  name: 'Elena',
  location: 'Miami',
  time: '2 minutos'
}, {
  name: 'Carmen',
  location: 'Guadalajara',
  time: '1 minuto'
}, {
  name: 'Ana',
  location: 'Medellín',
  time: '30 segundos'
}, {
  name: 'Gabriela',
  location: 'Monterrey',
  time: '5 minutos'
}];
export function RecentPurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    function showNotification() {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setPurchase(randomPurchase);
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
        // Schedule next notification
        setTimeout(showNotification, Math.random() * 15000 + 10000); // 10-25 seconds delay
      }, 4000);
    }
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-sm w-full animate-slide-up" data-id="element-309">
      <div className="bg-white rounded-xl shadow-lg border border-orange-100 p-4 flex items-center gap-4 relative overflow-hidden" data-id="element-310">
        <div className="absolute top-0 left-0 w-1 h-full bg-green-500" data-id="element-311"></div>
        <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-312">
          <XIcon className="w-4 h-4" data-id="element-313" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0 text-green-600" data-id="element-314">
          <ShoppingBagIcon className="w-5 h-5" data-id="element-315" />
        </div>

        <div data-id="element-316">
          <p className="text-sm font-bold text-gray-800" data-id="element-317">
            Nueva compra verificada
          </p>
          <p className="text-xs text-gray-600" data-id="element-318">
            <span className="font-semibold text-orange-700" data-id="element-319">
              {purchase.name}
            </span>{' '}
            de {purchase.location}
          </p>
          <p className="text-xs text-gray-400 mt-0.5" data-id="element-320">Hace {purchase.time}</p>
        </div>
      </div>
    </div>;
}